import React from 'react';
import { Link } from 'react-router';
import ErrorBox from '../../Common/ErrorBox/ErrorBox';
import { HTMLTrans, TransAnchor } from '../../Common/Translations';
import OrderPaymentDetails from './OrderPaymentDetails';
import { roundCurrency } from "../../Common/Helper";

const Header = (props) => {
  const {
    className = 'd-lg-flex',
    label,
    value,
  } = props;
  return (
    <div className={className}>
      <div>{label}<span className='d-none d-lg-inline'>:&nbsp;</span></div>
      <div className='ProximaNova-Bold'>{value}</div>
    </div>
  );
};

const Shipping = (props) => {
  const {
    shippingAddress
  } = props;
  return (
    <div className='row d-lg-flex'>
      <div className='small col-lg-12'>
        <div className='ProximaNova-Bold'><HTMLTrans id="account.order_ordercard_shipping_title">Shipping Address</HTMLTrans></div>
        <p>{shippingAddress}</p>
      </div>
      <div className='col-12 d-lg-none'><hr className='bg-gray-lighten-2 mt-2'/></div>
    </div>
  );
};

const Promotion = (props) => {
  return (
    <div className='row d-lg-flex'>
      <div className='small col-lg-12'>
        <div className='ProximaNova-Bold mb-1'><HTMLTrans id="account.order_ordercard_promotion_title">Voucher Purchase</HTMLTrans></div>
          <p>
          <HTMLTrans id="account.order_ordercard_promotion_description_1">Your voucher can be found at</HTMLTrans>
              <b className="ProximaNova-Bold"> <TransAnchor url="/account/dashboard/voucher" className="text-gray-darken-1 d-none d-lg-inline" name={<HTMLTrans id="account.order_ordercard_promotion_description_2">My Vouchers</HTMLTrans>} /></b>
              <span className='d-lg-none'> <nobr><HTMLTrans id="account.order_ordercard_promotion_description_2">My Vouchers</HTMLTrans></nobr></span> page
          </p>
      </div>
      <div className='col-12 d-lg-none'><hr className='bg-gray-lighten-2 mt-2'/></div>
    </div>
  );
};

const Subscription = (props) => {
  return (
    <div className='row d-lg-flex'>
      <div className='small col-lg-12'>
        <div className='ProximaNova-Bold mb-1'>Photobook Pass Purchase</div>
        <p>Your Photobook Pass can be found at&nbsp;
          <b className="ProximaNova-Bold">
            <Link to="/account/dashboard/voucher"
                  className="text-gray-darken-1 d-none d-lg-inline">My Photobook Pass</Link>
          </b>
          <span className='d-lg-none'><nobr>My Photobook Pass</nobr></span>&nbsp;page
        </p>
      </div>
      <div className='col-12 d-lg-none'>
        <hr className='bg-gray-lighten-2 mt-2'/>
      </div>
    </div>
  );
};

export const OrderCard = (props) => {
  const {
    orderNumber = '',
    date = '',
    currency = '',
    total = '',
    displayOptions,
    status,
    storeCreditUsed,
    shippingCreditUsed
  } = props;

  const CardFooter = (props) => {
    if (displayOptions.hasProject) {
      return (<Shipping {...props}/>);
    }

    if (displayOptions.hasPromotion) {
      return (<Promotion {...props}/>);
    }

    if (displayOptions.hasPromotionGroup) {
      return (<Promotion {...props}/>);
    }

    return (<Subscription {...props}/>);
  };

  const orderTotal = `${currency} ${roundCurrency(total + storeCreditUsed + shippingCreditUsed)}`;

  return (
    <div className='card mb-4 border-primary'>
      <div className='d-flex card-header bg-primary text-center justify-content-around justify-content-lg-between'>
        <Header
          label={<HTMLTrans id="account.order_ordercard_header_orderID">Order ID</HTMLTrans>}
          value={orderNumber}
        />
        <div className='vertical-divider d-inline d-lg-none'>
          <div className="column"></div>
        </div>
        <Header
          className='d-lg-flex'
          label={<HTMLTrans id="account.order_ordercard_header_date">Date</HTMLTrans>}
          value={date}
        />
      </div>
      <div className='card-body'>
        {props.children}
      </div>
      <div className='card-footer bg-gray-lighten-4 border-top-0'>
        <div className='container d-lg-flex flex-row justify-content-between p-0 p-md-2'>
          <div className='col-lg-6 p-0'>
            <CardFooter {...props}/>
          </div>
          <div className='col-lg-6 p-0'>
            <OrderPaymentDetails orderTotal={orderTotal} {...props} />
          </div>
        </div>
        <ErrorBox status={status}/>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Account/Order/OrderCard.js